import React, { useState } from "react"
import { Divider, Tabs, Tab } from '@mui/material';
import UserPassword from '../components/userSettingsComponents/UserPassword'
import APIToken from '../components/userSettingsComponents/APIToken'
import styles from './UserSettings.module.scss'

const TabPanel = ({ children, value, activeTab}) => value === activeTab && children

const UserSettingsPage = () => {
    const [activeTab, setActiveTab] = useState('password')

    const handleChange = (_, newValue) => setActiveTab(newValue)

    const userSettengsTabs = [
        <Tab label="Password" value="password" key="password" />,
        <Tab label="API Token" value="api_token" key="api_token" />,
    ]
    
    const userTabsPanel = [
        <TabPanel value="password" activeTab={activeTab} key="password">
            <UserPassword/>
        </TabPanel>,
        <TabPanel value="api_token" activeTab={activeTab} key="api_token">
            <APIToken/>
        </TabPanel>,
    ]

    return (
        <div className={styles['settings_container']}>
            <h1>Settings</h1>
            <Divider/>
            <div className={styles['settings_tabs_container']}>
                <div className={styles['tabs']}>
                    <Tabs 
                        orientation="vertical"
                        value={activeTab} 
                        onChange={handleChange}
                    >
                        {userSettengsTabs}
                    </Tabs>
                </div>
                <div>
                    {userTabsPanel}
                </div>
            </div>
        </div>
    )
}

export default UserSettingsPage